import { render } from "./CaixaModal.vue?vue&type=template&id=6563e85f&scoped=true&ts=true"
import script from "./CaixaModal.vue?vue&type=script&lang=ts"
export * from "./CaixaModal.vue?vue&type=script&lang=ts"

import "./CaixaModal.vue?vue&type=style&index=0&id=6563e85f&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6563e85f"]])

export default __exports__